import { getFoundation } from '../foundation';

import type { ThemeOptions } from '@mui/material';
import type { ThemeMode } from '../foundation';

export const createShadows = (themeMode: ThemeMode): ThemeOptions['shadows'] => {
  const foundation = getFoundation(themeMode);

  return [
    `none`,
    foundation.elevation.level_1,
    foundation.elevation.level_2,
    foundation.elevation.level_3,
    foundation.elevation.level_4,
    foundation.elevation.level_5,
    foundation.elevation.level_6,
    foundation.elevation.level_6,

    // 피그마에 level 6까지 정의되어 있고, MUI에는 level 24까지 정의되어 있어서 최고 레벨로 나머지를 채움
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
    foundation.elevation.level_6,
  ];
};
